export default __webpack_public_path__ + "static/media/tensorflow.b47133e8.svg";